import setTitleCase from './setTitleCase';
import formatNameCaseWithSplitterAndSpacer from './formatNameCaseWithSplitterAndSpacer';
import getStateFromAbbr from './getStateFromAbbr';
/**
 * Convert address pieces from search params into a formatted string for display
 *
 * @param {object} opts
 * @param {string} opts.streetRaw
 * @param {string} opts.cityRaw
 * @param {string} opts.stateAbbrRaw
 * @param {string} opts.zipCode
 * @param {string} opts.useFullStateName
 * @returns {string}
 */
const formatFullAddressFromParams = (opts = {}) => {
  if (!opts || !opts.streetRaw || !opts.cityRaw || !opts.stateAbbrRaw) {
    return '';
  }

  const { streetRaw, cityRaw, stateAbbrRaw, zipCode, useFullStateName } = opts;

  const street = setTitleCase({
    text: streetRaw.replace(/-/g, ' ')
  })
    .replace(/Po|P\/O/, 'PO')
    .replace('|', '#');
  const state = useFullStateName
    ? getStateFromAbbr({
        stateAbbr: stateAbbrRaw.toUpperCase(),
        includeTerritories: true
      })
    : stateAbbrRaw.toUpperCase();
  const city = formatNameCaseWithSplitterAndSpacer({
    name: cityRaw.replace(/_|-/g, ' ')
  });
  let address = `${street}, ${city}, ${state}`;
  if (zipCode) {
    return `${address} ${zipCode}`;
  }
  return address;
};

export default formatFullAddressFromParams;
